import { FormikProps } from 'formik';
import { PromoFormValues } from 'types/promotion/promotionTypes';
import {
  formatNumberWithCommasAnd2Decimals,
  formatPercentageInput,
} from 'utils/maths/InputFormats';

export const handleOnKeyUpNumberInput = (
  e: React.KeyboardEvent<HTMLInputElement>,
  formik: FormikProps<PromoFormValues>
) => {
  const { name, value } = e.currentTarget;

  const rawValue = formatNumberWithCommasAnd2Decimals(value);
  formik.setFieldValue(name, rawValue);
};

export const handleChangeNumberInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<PromoFormValues>
) => {
  const { name, value } = e.target;

  let rawValue = formatNumberWithCommasAnd2Decimals(value);
  if (rawValue === '-') rawValue = '';
  formik.setFieldValue(name, rawValue);
  formik.setFieldTouched(name, true);
};

export const handleOnKeyUpPercentageInput = (
  e: React.KeyboardEvent<HTMLInputElement>,
  formik: FormikProps<PromoFormValues>
) => {
  const { name, value } = e.currentTarget;

  const rawValue = formatPercentageInput(value);
  formik.setFieldValue(name, rawValue);
};

export const handleChangePercentageInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<PromoFormValues>
) => {
  const { name, value } = e.target;

  let rawValue = formatPercentageInput(value);
  if (rawValue === '-') rawValue = '';

  formik.setFieldValue(name, rawValue);
  formik.setFieldTouched(name, true);
};
